export default "__VITE_ASSET__290f3c75__"